import Q, { STORAGE_KEYS as o } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new Q.ee(null, !0).br(o.se);
}
